module.exports = __webpack_public_path__ + "img/devise-moodboard.44f521d3.jpg";